var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-avatar-link',[_c('gl-avatar-labeled',{staticClass:"gl-align-items-center",attrs:{"size":32,"label":_vm.userLabel,"sub-label":_vm.user.username,"src":_vm.user.avatarUrl || _vm.user.avatar || _vm.user.avatar_url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }